import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { Dropdown, DropdownProps } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { useMemo, useState } from "react";
import Arrow from "../../../assets/images/arrow-right.svg";
import { CodeEditorInDialog } from "../../code/CodeEditorInDialog";
import "./avro.scss";
import CorrespondanceTypeDropDown from "./correspondanceTypeDropDown";
import CorrespondanceTypeImage from "./correspondanceTypeImage";

export interface Types {
  name: string;
  type: any;
}

export const selectedTypesTemplate = (option: Types, props: DropdownProps) => {
  if (option) {
    return TypesOptionTemplate(option);
  }
  return <span>{props.placeholder}</span>;
};

export const TypesOptionTemplate = (option: Types) => {
  return (
    <div className="flex align-items-center">
      <img
        alt={option.name}
        src={CorrespondanceTypeImage(option.type)}
        className="mr-2"
        style={{
          width: "1.5rem",
          backgroundColor: "#f0f3f5",
          padding: "0.05rem",
        }}
      />
      <div>{option.name}</div>
    </div>
  );
};

export const Field = ({
  name,
  drag,
  type,
  UpdateValue,
  remove,
}: {
  name: string;
  drag: any;
  type: any;
  UpdateValue: (types: Types) => void;
  remove: () => void;
}) => {
  const [value, setValue] = useState<Types | undefined>(
    CorrespondanceTypeDropDown(type)
  );  
  const [codeEditorValue,setCodeEditorValue] = useState<any>(type);

  const UpdateComplexValue  = (myEditorValue: any) => {
    try {
     const json = JSON.parse(myEditorValue);
     UpdateValue({name:name,type:json})
    } catch (e) {
      UpdateValue({name:name,type:myEditorValue})
    }
    setCodeEditorValue(myEditorValue)
  }

  const types: Types[] = [
    { name: "Chaine de caractère", type: "string" },
    { name: "Nombre entier (int)", type: "int" },
    { name: "Nombre entier (long)", type: "long" },
    { name: "Nombre décimal (float)", type: "float" },
    { name: "Nombre décimal (double)", type: "double" },
    { name: "Octets", type: "bytes" },
    { name: "Booléen", type: "boolean" },
    { name: "Complexe", type: "complex" },
  ];



  return (
    <>
      <div className="rowAvro">
        <div className="grip" {...drag}>
          <FontAwesomeIcon className="icon" icon={"grip-vertical"} />
        </div>
        <div className="fields">
          <div className="dropDown">
            <Dropdown
              value={value}
              onChange={(e) => {
                setValue(e.value);
                UpdateValue({
                  name: e.target.value.replace(/\s/g, ''),
                  type: e.value?.type !== "complex" ? e.value?.type ?? "" : ""
                  });
              }}
              options={types}
              optionLabel="name"
              placeholder="Selectionner un type"
              className="w-full h-full"
              itemTemplate={TypesOptionTemplate}
              valueTemplate={selectedTypesTemplate}
            />
          </div>
          <div className="input">
            <InputText
              value={name}
              className="w-full h-full"
              onChange={(e) => {
                if (value?.type !== "complex")
                  UpdateValue({
                    name: e.target.value.replace(/\s/g, ''),
                    type: value?.type ? value.type : "",
                  });
                else
                  UpdateValue({
                    name: e.target.value.replace(/\s/g, ''),
                    type: type,
                  });
              }}
            />
          </div>
        </div>

        <div className="cross">
          <FontAwesomeIcon
            className="icon"
            icon={"xmark"}
            onClick={() => {
              remove();
            }}
          />
        </div>
      </div>
      {value?.type === "complex" && (
        <div className="mt-1 complex">
          <img
            alt={"fléches"}
            src={Arrow}
            className="mr-2"
            style={{
              width: "1.6rem",
            }}
          />{" "}
          <CodeEditorInDialog
            lang={"avro"}
            defaultValue={JSON.stringify(codeEditorValue, null, 4) ? JSON.stringify(codeEditorValue, null, 4) : ""}
            onChange={UpdateComplexValue}
            buttonType={"icon"}
            buttonValue={"pi pi-pencil"}
          />
        </div>
      )}
    </>
  );
};
